import React from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Alert, CircularProgress, Stack, Typography } from '@mui/material';

import { useGetOffer } from '~/hooks/apis/offers/useGetOffer';

import ChatterFeed from './Chatter/ChatterFeed';

export default function OfferBuilderFeedPage() {
  const { id_offer: offerId } = useParams<{ id_offer: string }>();
  const { data: offer, isPending, isError, error } = useGetOffer(offerId);
  const opportunityId = offer?.id_salesforce_external;

  const renderFeed = () => {
    if (isPending) {
      return (
        <Stack alignItems="center" py={4}>
          <CircularProgress />
        </Stack>
      );
    }
    if (isError) {
      return <Alert severity="error">Failed to load the offer: {error.message}</Alert>;
    }
    if (!opportunityId) {
      return <Alert severity="info">This offer isn't linked to a Salesforce opportunity, so it has no feed.</Alert>;
    }
    return <ChatterFeed parentType="opportunity" parentId={opportunityId} scopeLabel="opportunity" />;
  };

  return (
    <>
      <Helmet>
        <title>Feed | Offer Builder</title>
      </Helmet>

      <Typography variant="h4" sx={{ mb: 2 }}>
        Feed
      </Typography>
      {renderFeed()}
    </>
  );
}
